<template lang="pug">
  .menu-categories
    .background-header.white
      v-container.white.pb-1(style="max-width:600px")
        div.my-2.mx-2
          v-text-field(v-model="searchText" :placeholder="$t('search_category')" hide-details dense outlined height="40" background-color="basic200")
            template(v-slot:append)
              eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
        div.my-2.mx-2.d-flex.align-center
          v-btn.s1.text-capitalize.px-0(v-if="member.role === 'Admin'" color="textColorAccent" text @click="showAddMenuDialog = true")
            eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="20" height="20" style="margin-top: 3px")
            | {{$t('create_new_category')}}
          v-spacer
          v-btn.basic600--text.label.px-0(color="transparent" text small @click="showSort = !showSort")
            v-icon(color="basic600" size="20") mdi-sort
            | {{ $t('sort') }}

    v-container.pa-0.mb-4(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .contain-layout.mx-2(v-else)
        v-layout.my-6(v-if="categories.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption {{ $t('no_categories_yet') }}
        template(v-else)
          draggable.my-2(tag="div" handle=".handle" :list="categories" @start="drag=true" @end="endMove" :move="checkMove")
            template(v-for='category in categories')
              category-item(:category="category" :company="company" :key="category.id" @deleted="handleDeleteItem" :drag.sync="drag" :showSort="showSort")

      y-pagination.ma-4(v-model="page" :pageSize="fetchCount" :count="count")

    .modals
      add-menu-category(v-if="showAddMenuDialog" :open.sync="showAddMenuDialog" :company="company" @added="handleAddItem")

</template>

<script>
import { mapState, mapActions } from 'vuex'
import queryString from 'query-string'
import AddMenuCategory from '@/components/restaurant/dialogs/AddMenuCategory.vue'
import CategoryItem from '@/components/restaurant/CategoryItem.vue'
import draggable from 'vuedraggable'

export default {
  name: 'MenuCategories',
  components: { AddMenuCategory, CategoryItem, draggable },
  props: ['company'],
  data: () => ({
    isFetching: false,
    showAddMenuDialog: false,
    selectedStyle: 0,
    fetchCount: 10,
    page: 1,
    // totalPage: 1,
    searchText: '',
    categories: [],
    totalCount: 0,
    count: 0,
    searchCountDown: null,
    publishedFormCount: 0,
    showSort: false,
    drag: false,
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapState('subscriptions', ['yezzaSubscription']),
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        if (this.searchText) {
          this.searchItem(val)
        } else {
          this.fetchCategories(val)
        }
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem(1)
      }, 500)
    }
  },
  mounted () {
    if (!this.$route.query.page) {
      this.fetchCategories(1)
    } else {
      this.fetchCategories(this.$route.query.page)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchCategories(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/product_categories/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&app=pos`
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.categories = response.data.results
        this.totalCount = response.data.count
        this.count = response.data.count
      })
      .catch((error) => {
        if (error.response.data.detail === 'Invalid page.') {
          this.fetchCategories(1)
        }
      })
    },
    searchItem (page) {
      this.page = parseInt(page)
      let searchUrl = searchUrl = `/product_categories/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.categories = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
    },
    handleDeleteItem (item) {
      this.categories = this.categories.filter((x) => x !== item)
    },
    handleAddItem (item) {
      this.categories.push(item)
    },
    checkMove (e) {
      let fromCategory = this.categories[e.draggedContext.index]
      let toCategory = this.categories[e.draggedContext.futureIndex]
      this.params = {
        category: toCategory.id,
        direction: e.draggedContext.futureIndex > e.draggedContext.index ? 'down' : 'up'
      }
      this.fromCategoryId = fromCategory.id
    },
    endMove () {
      this.drag = false
      if (!this.fromCategoryId) {
        return
      }
      if (this.fromCategoryId === this.params.category) {
        return
      }
      this.$axios.post(`/product_categories/${this.fromCategoryId}/move/`, this.params).catch(() => {})
    },
    // handleEditItem (item) {
    //   let editIndex = 0
    //   this.forms.forEach((form, index) => {
    //     if (form.id === item.id) {
    //       editIndex = index
    //     }
    //   })
    //   this.forms = this.forms.filter((x) => x.id !== item.id)
    //   this.forms.splice(editIndex, 0, item)
    // },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>